import { render, staticRenderFns } from "./trsReturnPolicy.vue?vue&type=template&id=d62693d8&scoped=true"
import script from "./trsReturnPolicy.vue?vue&type=script&lang=js"
export * from "./trsReturnPolicy.vue?vue&type=script&lang=js"
import style0 from "./trsReturnPolicy.vue?vue&type=style&index=0&id=d62693d8&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d62693d8",
  null
  
)

export default component.exports